import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService, LanguageService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { AppLabels } from '../../utils/appLabels.class';

@Injectable()
export class TimeToRepairPluginService extends InspectionPluginService {
  public reparators: any = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private language: LanguageService,
    private inspectionFactory: InspectionFactoryService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public updateTimeToRepair(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    timeToRepairs: any
  ): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, timeToRepairs).pipe(
      map((res: InspectionPlugin) => {
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getReparators() {
    return this.reparators;
  }

  private applyTranslations() {
    this.reparators = [];
    this.copyTranslationValues(AppLabels.REPARATOR_KEYS, this.reparators, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, timeToRepairs: any): Observable<any> {
    return this.inspectionFactory
      .updatePluginConfig(inspectionId, pointId, pluginId, timeToRepairs, 'TimeToRepairs')
      .pipe(
        flatMap((plugin) => {
          if (this.isInspectionInOffline(inspectionId)) {
            return of(plugin);
          }
          return this.apiService.post(plugin.postServerUrl, plugin.config);
        })
      );
  }
}
